import { Config } from "@/shared/config";

const EmployerBase = Config.FileContributionServicebaseUri + "/filecontribution/v1/employer";

export default {
  uploadFundingFile (employerId: number) {
    return `${EmployerBase}/${employerId}/funding-file-upload`;
  },
  priorYear (employerId: number) {
    return `${EmployerBase}/${employerId}/prior-year-contribution-cutoff`;
  },
  nextYearProcessDate (employerId: number) {
    return `${EmployerBase}/${employerId}/next-year-contribution-cutoff`;
  },
  getEmployerContributionFileInfo: (employerId: number, pageNumber: number, pageSize: number, sortOrder: string) =>
    EmployerBase + `/${employerId}/funding-file-info/${pageNumber}?pageSize=${pageSize}&sortOrder=${sortOrder}`,
  downloadFundingFileSummary: (employerId: number, id: number) =>
    EmployerBase + `/${employerId}/funding-file-summary-download/${id}`,
  cancelFundingFileProcess: (employerId: number, id: number) =>
    EmployerBase + `/${employerId}/cancel-funding-file/${id}`,
  getEmployerContributionsDetails: (employerId: number, id: number) =>
    EmployerBase + `/${employerId}/funding-file-summary/${id}`,
  getPendingContributionsReport (employerId: number, pageNumber: number, pageSize: number,
    displayExpiredContributionsOnly: boolean) {
      return EmployerBase +
        `/${employerId}/pending-contributions-report/${pageNumber}?pageSize=${pageSize}&displayExpiredContributionsOnly=${displayExpiredContributionsOnly}`;
  },
  getPendingContributionsReportDownload (employerId: number, displayExpiredContributionsOnly: boolean) {
    return `${EmployerBase}/${employerId}/pending-contributions-report-download?displayExpiredContributionsOnly=${displayExpiredContributionsOnly}`;
  },
  getEmployeeProcessedHoldOverReportDownload (employerId: number, payrollDate: string) {
    return `${EmployerBase}/${employerId}/cleared-hold-over-contributions-report-download/${payrollDate}`;
  },
  getProcessedHoldOverAmountByPayrolldates (employerId: number) {
    return `${EmployerBase}/${employerId}/holdoveramount-by-processdate`;
  },
  fileProcessorSettings (employerId: number) {
    return `${EmployerBase}/${employerId}/settings`;
  },
  cancelContributionHolds (employerId: number) {
    return `${EmployerBase}/${employerId}/cancel-contribution-holds`;
  },
  employerSftpVendorType (employerId: number) {
    return `${EmployerBase}/${employerId}/sftp-setting`;
  },
  employerSftpMap (employerId: number) {
    return `${EmployerBase}/${employerId}/sftp-map`;
  },
  employerSftpMapDelete (employerId: number, sftpMapId: number) {
    return `${EmployerBase}/${employerId}/sftp-map/${sftpMapId}/delete`;
  }
};